<template>
  <div class="Popover" ref="popover" v-click-outside="closePopover">
    <div class="popover" :style="style">
        <ul class="list-block -tiny">
          <li class="item" v-for="option in atuacaoOptions">
            <button type="button" class="btn -dropdown -small"  :href="option.href" @click="goToRoute(option)">{{ option[label] }}</button>
          </li>
        </ul>
    </div>
  </div>
</template>

<script>
  import DomHelper from '../utils/dom';
  export default {
    data() {
      return {
        popover: null,
        position: { top: 0, left: 0},
        scrollableElement: null
      };
    },
    props: {
      options: { required: true, default: {} },
      label: { default: 'label' },
      target: { required: true }
    },
    computed: {
      atuacaoOptions() {
        return this.options;
      },
      style() {
        return {
          top: this.position.top,
          left: this.position.left
        }
      }
    },
    mounted() {
      this.scrollableElement = DomHelper.getScrollParent(typeof this.target[0] !== 'undefined' ? this.target[0] : this.target);
      if (this.scrollableElement) {
        if (this.scrollableElement.localName === 'html') {
          this.scrollableElement = window;
        }
        this.scrollTop = this.scrollableElement.scrollY;
        this.scrollableElement.addEventListener('scroll', this.closePopover);
      }
      this.getPosition();
    },
    beforeDestroy() {
      this.scrollableElement.removeEventListener('scroll', this.closePopover);
    },
    methods: {
      getPosition() {
        let position = DomHelper.getElementPosition(typeof this.target[0] !== 'undefined' ? this.target[0] : this.target);
        this.position.top = (position.top + 40) + 'px';
        this.position.left = (position.left - 200) + 'px';
      },
      closePopover(event) {
        this.$emit('close-popover');
      },
      goToRoute(option) {
        this.closePopover();
        if (typeof option.route !== 'undefined' && option.route.name) {
          this.$router.push(option.route);
        } else if (option.href !== 'undefined'){
          window.location = option.href;
        }
      }
    }
  }
</script>

<style lang="stylus">
.Popover
  z-index 10
  .popover
    position fixed
    transform-origin top right
    will-change transform
    animation showLikeMaterial 0.15s ease-in-out forwards
  .list-block > .item
    padding 6px 12px

</style>
